import { fetchAll } from "@/use/repositories/assets/fetchAll";

export async function fetchByCustomer(customerId, loading = true) {
  return fetchAll({
    action: "by_customer",
    customer_id: customerId,
  }, loading);
}
